// Author YuJiaBei
// Date 2020-08-07 16:27:20

class EmArchCostStatisticType {
constructor({
        id = null,
        name = '',
        parentId = '',
        seq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.parentId = parentId;
    this.seq = seq;
    this.remark = remark;
}
}

function newEntity() {
return new EmArchCostStatisticType();
}

function gridFields() {
return Object.freeze([
        {
        key: 'name',
        label: 'label.em.archive.emArchCostStatisticType.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.em.archive.emArchCostStatisticType.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchCostStatisticType.grid.remark',
        sortable: true,
        form: {
        type: 'input'
        }
        }
]);
}

const filter = {
    nameFilter : "",
    parentIdFilter : "",
    levelFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.archive.emArchCostStatisticType.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentIdFilter',
        label: 'label.em.archive.emArchCostStatisticType.filter.parentId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchCostStatisticType'
            ,correspondingField: 'id'
                }
        },
];

const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.archive.emArchCostStatisticType.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'parentId',
        label: 'label.em.archive.emArchCostStatisticType.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchCostStatisticType'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'seq',
        label: 'label.em.archive.emArchCostStatisticType.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchCostStatisticType.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmArchCostStatisticType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
